"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _Toggle = _interopRequireDefault(require("../helpers/Toggle"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _List = _interopRequireDefault(require("../List/List"));
var _constants = require("../constants");
var _envConstants = require("../../env-constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var phoneNumbers;
switch (_envConstants.ENV.SITE) {
  case 'ynf':
    phoneNumbers = _constants.PHONE_NUMBERS.YNF;
    break;
  case 'tsw':
    phoneNumbers = _constants.PHONE_NUMBERS.TSW;
    break;
  case 'tyw':
    phoneNumbers = _constants.PHONE_NUMBERS.TYW;
    break;
  default:
    phoneNumbers = _constants.PHONE_NUMBERS.TYW;
}
var PhoneNumber = function PhoneNumber(_ref) {
  var color = _ref.color,
    setExternalModalToggle = _ref.setExternalModalToggle,
    menuOn = _ref.menuOn,
    outline = _ref.outline;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-phone-number inline-flex"
  }, /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var on = _ref2.on,
      toggle = _ref2.toggle;
    if (setExternalModalToggle) setExternalModalToggle(on);
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('flex', 'flex-center', menuOn && 'flex-column', outline && 'btn btn--sm btn--outline primary'),
      style: {
        cursor: 'pointer'
      },
      onClick: toggle,
      tabIndex: "0",
      role: "button",
      "aria-pressed": "false"
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: (0, _classnames["default"])(!menuOn && 'margin-right-xxs', 'icon--md'),
      name: "call",
      fill: color
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _classnames["default"])('d8-u-text-semi-bold', menuOn && 'text-xs d8-u-color-contrast-high')
    }, "Call us")), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      toggle: toggle,
      on: on
    }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
      heading: "Call Us",
      items: phoneNumbers,
      noNotificationText: true,
      noMaxHeight: true
    })));
  }));
};
PhoneNumber.propTypes = {
  color: _propTypes["default"].string,
  setExternalModalToggle: _propTypes["default"].func,
  menuOn: _propTypes["default"].bool,
  outline: _propTypes["default"].bool
};
PhoneNumber.defaultProps = {
  color: _constants.COLORS.SECONDARY
};
var _default = exports["default"] = PhoneNumber;